/**
 * LeadTimelineChart — recharts LineChart fuer DASH-04 (Phase 4 Plan 03).
 *
 * Zeigt Lead-Zugang der letzten 30 Tage als Zeitreihe.
 * X = Datum (TT.MM), Y = Anzahl neuer Leads.
 * Linie schwarz #1A1A1A, Dots gelb #E9FF57, Grid grau #DAD9D9.
 * Responsiv via ResponsiveContainer height=250.
 */

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
} from 'recharts';

interface TimelinePoint {
  date: string; // yyyy-MM-dd
  count: number;
}

interface LeadTimelineChartProps {
  data: TimelinePoint[];
}

function formatDate(dateStr: string): string {
  // yyyy-MM-dd → TT.MM (kurz fuer X-Achse)
  const parts = dateStr.split('-');
  if (parts.length < 3) return dateStr;
  return `${parts[2]}.${parts[1]}`;
}

export default function LeadTimelineChart({ data }: LeadTimelineChartProps) {
  const chartData = data.map((d) => ({ ...d, dateLabel: formatDate(d.date) }));

  return (
    <ResponsiveContainer width="100%" height={250}>
      <LineChart data={chartData}>
        <CartesianGrid strokeDasharray="3 3" stroke="#DAD9D9" />
        <XAxis
          dataKey="dateLabel"
          stroke="#1A1A1A"
          tick={{ fontSize: 11, fill: '#1A1A1A' }}
          interval={4}
        />
        <YAxis
          stroke="#1A1A1A"
          tick={{ fontSize: 11, fill: '#1A1A1A' }}
          allowDecimals={false}
          width={30}
        />
        <Tooltip
          contentStyle={{ borderColor: '#DAD9D9', fontSize: 12 }}
          formatter={(value: number) => [value, 'Neue Leads']}
          labelFormatter={(label: string) => `Datum: ${label}`}
        />
        <Line
          type="monotone"
          dataKey="count"
          stroke="#1A1A1A"
          strokeWidth={2}
          dot={{ fill: '#E9FF57', r: 3, stroke: '#1A1A1A', strokeWidth: 1 }}
          activeDot={{ r: 5, fill: '#E9FF57', stroke: '#1A1A1A' }}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}
